import { AddCircleIcon, IconSize, IconWrapper, Link, Tooltip } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../translations';
import { PreInterviewCreateModalOpener } from '../../../preInterview/create/PreInterviewCreateModal.opener';

import { isAppointmentBeganMoreThanDayAgo } from './PreInterviewCreateLink.utils';

type PreInterviewCreateLinkProps = {
   readonly appointmentId: number;
   readonly beginDate: Date;
   readonly endDate: Date;
   readonly patientFullName: string;
   readonly disabled: boolean;
};

export const PreInterviewCreateLink = (props: PreInterviewCreateLinkProps): JSX.Element => {
   const disabled = props.disabled || isAppointmentBeganMoreThanDayAgo(props.beginDate);

   return (
      <PreInterviewCreateModalOpener
         appointmentId={props.appointmentId}
         beginDate={props.beginDate}
         endDate={props.endDate}
         patientFullName={props.patientFullName}
      >
         {({ openModal }) => (
            <Tooltip
               content={appointmentsTranslationKeys.preInterview.table.column.actions.create.tooltipContent}
               testId={'preInterviewTooltip'}
               maxWidth={'486px'}
               disabled={!disabled}
            >
               <Link
                  testId={'createPreInterview'}
                  label={appointmentsTranslationKeys.preInterview.table.column.actions.create.title}
                  icon={
                     <IconWrapper size={IconSize.SMALL} disabled={disabled} testId={'addCircleIcon'}>
                        <AddCircleIcon />
                     </IconWrapper>
                  }
                  onClick={openModal}
                  disabled={disabled}
               />
            </Tooltip>
         )}
      </PreInterviewCreateModalOpener>
   );
};
